import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import updateAction from './updateAction';
// import { debounce } from '../../../../../_helpers/_methods';
import { FormattedMessage } from 'react-intl';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';
import { useSelector } from 'react-redux';

function OrganizationStep4() {
  const rosterData = useSelector((state) => state.rosters.rosters);

  const { actions } = useStateMachine({ updateAction });
  const { state } = useStateMachine({ updateAction });
  const navigate = useNavigate();
  const { id, edit: isEdit } = useParams();
  const location = useLocation();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });

  const [resourcePersonList, setResourcePersonList] = useState({});
  useEffect(() => {
    const getResourcePerson = async () => {
      try {
        let response = await fetchWrapper.get('/profile/resource-person/?limit=20');
        setResourcePersonList(
          response.data.results.map((list) => ({ label: list.fullname, value: list.id }))
        );
      } catch (error) {
        console.log(error);
      }
    };
    getResourcePerson();
  }, []);

  const searchResourcePerson = async (e) => {
    try {
      let response = await fetchWrapper.get(
        `/profile/resource-person/?fullname=${e.label}&limit=50`
      );
      setResourcePersonList(
        response.data.results.map((list) => ({ label: list.fullname, value: list.id }))
      );
      setValue('associated_resource_person', e);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isEdit) {
      setValue('organization_remarks', rosterData?.remarks);
    }
  }, []);
  const onSubmit = (data) => {
    actions.updateAction(data);
    let path = location.pathname.split('/');

    if (isEdit) {
      navigate(`/admin/rosters/organization/${id}/edit/5`);
    } else {
      path.includes('admin')
        ? navigate('/admin/rosters/organization_apply/5')
        : navigate('/rosters/organization_apply/5');
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-6">
            <div className="my-4">
              <h3 className="mb-4 pl-2">
                <FormattedMessage id="remarks" />
              </h3>
            </div>
            <FormattedMessage id="remarks_placeholder">
              {(id) => (
                <FormGroup
                  id="organization_remarks"
                  type="textarea"
                  placeholder={id[0]}
                  label={<FormattedMessage id="mention_remarks" />}
                  defaultValue={state.organization_remarks}
                  register={register}
                  error={errors}
                />
              )}
            </FormattedMessage>
          </div>

          <div className="col-md-6">
            <div className="my-4">
              <h3 className="mb-4">
                <FormattedMessage id="associated_resource_person" />
              </h3>
            </div>
            <div className="pl-4">
              <ul className="text-danger">
                <li style={{ listStyleType: 'disc' }}>
                  Please type the name of the resource person in the search field below. And click
                  the name as it appears.
                </li>
                <li style={{ listStyleType: 'disc' }}>Try names in both Nepali and English.</li>
                <li style={{ listStyleType: 'disc' }}>
                  If you cannot find the name, the resource person might not have registered. So,
                  please ask the person to register from
                  <Link
                    className="text-info ml-2 text-decoration-underline"
                    to="/rosters/individual_apply"
                    target="_blank">
                    Here
                  </Link>
                </li>
              </ul>

              <FormGroup
                id="associated_resource_person"
                type="select"
                className=""
                placeholder="Search for resource person"
                register={register}
                options={resourcePersonList}
                onChange={(e) => searchResourcePerson(e)}
                default
                label={<FormattedMessage id="choose_associated_resource_person" />}
                error={errors}
                isMulti={true}
              />
              {/* {SearchList} */}
            </div>
          </div>
        </div>

        <div className="">
          <hr />
          <NavigationButtonGroup
            backTo="/admin/rosters/organization_list"
            //  showSubmit={id}
          />
        </div>
      </form>
    </div>
  );
}

export default OrganizationStep4;
